import {Epic} from 'redux-observable';
import {Action, Reducer} from 'redux';
import {PropertyID} from 'module/Properties/enum/PropID';
import React, {ElementType} from 'react';
import {AppModuleType} from 'common/AppModule';
import {assign, uniq} from 'lodash';
import {UrlParamModule} from 'module/UrlParam/UrlParamModule'

export interface Module {
	reducerNS?: Record<string, Reducer>
	epics?: Epic[]
	properties?: PropertyID[]
	actions?: Action[]
	modules?: Module[]
	Component?: ElementType
}

function flattenModules(ret: Module[], subModules: Module[]): Module[] {
	if (!subModules.length) return ret;
	subModules = subModules.filter(sm => !ret.includes(sm))
	ret = [...ret, ...subModules]
	return flattenModules(ret, subModules.flatMap(m => m.modules || []))
}

export function enrichAppModule(appModule: AppModuleType, ...modules: Module[]): AppModuleType {
	modules = flattenModules(modules, modules.flatMap(m => m.modules || []))
	modules = uniq([
		// global dependency modules
		UrlParamModule,
		// app modules
		...(modules || []),
	])
	const properties = (appModule.properties || []).concat(...modules.map(m => m.properties || []))
	const ret: AppModuleType = {
		reducers: assign({}, appModule.reducers, ...modules.map(m => m.reducerNS).filter(x => x)),
		epics: (appModule.epics || []).concat(...modules.map(m => m.epics || [])).filter(x => x),
		properties: properties.filter((x, i) => x && properties.indexOf(x) === i),
		actions: (appModule.actions || []).concat(...modules.map(m => m.actions || [])).filter(x => x),
		App: () => <>
			<appModule.App/>
			{modules.map((m, i) => m.Component && <m.Component key={i}/>).filter(x => x)}
		</>,
	}
	return ret
}